import TripItem from "./TripItem"
export default TripItem
